// Sandbox-status state extracted from the chat WS stream. Phase 6.
//
// The orchestrator emits `sandbox_status` events whenever the per-session
// SandboxPhase transitions (idle → triggering → … → ready → degraded /
// terminated). The chat hook funnels those into the typed snapshot here,
// which the UI's `SandboxStatus` pill renders. The legacy `bridge_status`
// event continues to flow in parallel for backward compatibility with
// older `BridgeBadge` consumers; once phase 6 cuts the legacy event from
// the bridge translator, this becomes the only signal.

export type SandboxPhase =
  | "idle"
  | "triggering"
  | "waiting-for-runner"
  | "booting"
  | "ready"
  | "degraded"
  | "suspended"
  | "terminated";

export interface SandboxStatusSnapshot {
  readonly phase: SandboxPhase;
  readonly message?: string;
  readonly pipelineId?: number;
  /**
   * When this phase began, on the BROWSER's clock: the server's `since`
   * carried across the skew-free rule (arrival − (emittedAt − since)), or the
   * arrival of the first frame that named the phase when the server sent none.
   * Absent until a `sandbox_status` has arrived on this socket.
   */
  readonly sinceMs?: number;
}

export const INITIAL_SANDBOX_STATUS: SandboxStatusSnapshot = { phase: "idle" };
